import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Progress, Typography, Spin, message } from 'antd';
import { UsergroupAddOutlined, TeamOutlined, ThunderboltOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title, Text } = Typography;

const AdminDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await api.get('/admin/dashboard');
                setData(res.data);
            } catch (e) {
                message.error("Failed to load admin statistics");
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" /></div>;

    const getRoleCount = (role) => data?.users.find(u => u.role === role)?.total || 0;

    return (
        <div style={{ padding: '24px' }}>
            <Title level={2}>Platform Overview</Title>
            <Text type="secondary">Real-time statistics for Chalom Hights mentorship activities.</Text>

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} style={{ borderBottom: '4px solid #FE1F08' }}>
                        <Statistic 
                            title="Total Mentees" 
                            value={getRoleCount('mentee')} 
                            prefix={<UsergroupAddOutlined />} 
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} style={{ borderBottom: '4px solid #1890ff' }}>
                        <Statistic 
                            title="Active Mentors" 
                            value={getRoleCount('mentor')} 
                            prefix={<TeamOutlined />} 
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} style={{ borderBottom: '4px solid #52c41a' }}>
                        <Statistic 
                            title="Active Pairings" 
                            value={data?.pairings} 
                            prefix={<ThunderboltOutlined />} 
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                    <Card bordered={false} style={{ borderBottom: '4px solid #faad14' }}>
                        <Statistic 
                            title="Pending Support" 
                            value={data?.pending_tickets} 
                            prefix={<CustomerServiceOutlined />} 
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col span={24}>
                    <Card title="Global Goal Success Rate">
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Progress 
                                type="circle" 
                                percent={data?.milestones.rate} 
                                strokeColor="#FE1F08" 
                                width={180}
                            />
                            <div style={{ marginTop: 20 }}>
                                <Title level={4}>{data?.milestones.completed} Milestones Confirmed</Title>
                                <Text type="secondary">Out of {data?.milestones.total} total milestones set by all mentees.</Text>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AdminDashboard;